import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { ConfirmationPage } from '../../components/confirmation_page'

export const ConfirmationPagePanel = ({ isLocked, ...props }) => (
  <AccordionPanel
    titleId="confirmation-page-label"
    title={I18n.t('publisher.event_type_editor.sections.more_options.confirmation_page.title')}
    subheader={<Summary />}
    {...props}
  >
    <ConfirmationPage isLocked={isLocked} />
  </AccordionPanel>
)
